import { useState, useEffect, useCallback } from "react"
import { filterStore, FilterValue } from "../stores/filterStore"

type Filters = Record<string, FilterValue>

export function useFilterStore() {
  const [filters, setFilters] = useState<Filters>(() => filterStore.getAll())

  useEffect(() => {
    const onChanged = () => setFilters(filterStore.getAll())
    const onCleared = () => setFilters({})

    window.addEventListener("page:filter-changed", onChanged)
    window.addEventListener("page:filter-cleared", onCleared)
    return () => {
      window.removeEventListener("page:filter-changed", onChanged)
      window.removeEventListener("page:filter-cleared", onCleared)
    }
  }, [])

  const setFilter = useCallback((widgetId: string, filter: FilterValue) => {
    filterStore.set(widgetId, filter)
  }, [])

  const removeFilter = useCallback((widgetId: string) => {
    filterStore.remove(widgetId)
  }, [])

  const clearFilters = useCallback(() => {
    filterStore.clear()
  }, [])

  return { filters, setFilter, removeFilter, clearFilters }
}
